const code = {
    state: {
        codeCombo: {
            _TEMP_CODE: '',
        },
        codeTree: {},
        sysConfig: [],
    },
    getters: {
        getCodeComboList: state => {
            if (state.codeCombo._TEMP_CODE === '') {
                let sCodeCombo = JSON.parse(sessionStorage.getItem('codeCombo'))
                if (sCodeCombo !== null) {
                    state.codeCombo = sCodeCombo
                }
            }
        },
        getCodeCombo: state => codeTypeId => {
            if (!state.codeCombo.orgId) {
                let sCodeCombo = JSON.parse(sessionStorage.getItem('codeCombo'))
                if (sCodeCombo != null) {
                    state.codeCombo = sCodeCombo
                }
            }
            if (codeTypeId == undefined) {
                return []
            }
            return state.codeCombo[codeTypeId];
        },
        getCodeTreeList: state => {
            let sCodeCombo = JSON.parse(sessionStorage.getItem('codeTree'))
            if (sCodeCombo !== null) {
                state.codeTree = sCodeCombo
            }
        },
        getCodeTree: state => codeTypeId => {
            if (Object.keys(state.codeTree).length < 1) {
                let sCodeCombo = JSON.parse(sessionStorage.getItem('codeTree'))
                if (sCodeCombo != null) {
                    state.codeTree = sCodeCombo
                }
            }
            if (codeTypeId == undefined) {
                return []
            }
            return state.codeTree[codeTypeId];
        },
        getSysConfigList: state => {
            let sysConfig = JSON.parse(sessionStorage.getItem('sysConfig'))
            if (sysConfig !== null) {
                state.sysConfig = sysConfig
            }
        },
        getSysConfig: state => sysConfigId => {
            let config = sessionStorage.getItem('sysConfig')
            if (config == null) {
                return {}
            }
            let sysConfig = JSON.parse(config),
                result = {}
            for (let i of sysConfig) {
                if (i.configId == sysConfigId) {
                    result = i
                    break;
                }
            }
            if (sysConfigId == undefined) {
                return {}
            }
            return result;
        },
    },
    mutations: {
        SET_CODE_COMBO: (state, codeCombo) => {
            sessionStorage.setItem('codeCombo', JSON.stringify(codeCombo))
            state.codeCombo = {
                ...codeCombo
            }
        },
        SET_CODE_TREE: (state, codeTree) => {
            sessionStorage.setItem('codeTree', JSON.stringify(codeTree))
            state.codeTree = {
                ...codeTree
            }
        },
        SET_SYS_CONFIG: (state, sysConfig) => {
            sessionStorage.setItem('sysConfig', JSON.stringify(sysConfig))
            state.sysConfig = [...sysConfig]
        },
    },
    actions: {
        setCodeCombo(context, codeCombo) {
            context.commit('SET_CODE_COMBO', codeCombo)
        },
        setCodeTree(context, codeTree) {
            context.commit('SET_CODE_TREE', codeTree)
        },
        setSysConfig(context, sysConfig) {
            context.commit('SET_SYS_CONFIG', sysConfig)
        },
    },
}
  
export default code